import { PageSource } from '@mc/track-event'

export const FOR_YOU_EXP_FLAG = 'pen-4407_v1'
export const CATEGORY_TAGGED_PAGE_SOURCES = [
  PageSource.CLASS_PAGE,
  PageSource.SERIES_PAGE,
  PageSource.CATEGORY,
  PageSource.SUBCATEGORY,
] as string[]

export const FOR_YOU_INTEREST_KEY = 'for_you_interest'
export const FOR_YOU_INTEREST_EXPIRATION_MS = 24 * 60 * 60 * 1000
export const NUDGE_SHOW_DELAY_MS = 6000

export const FOR_YOU_INTEREST_UPDATED_EVENT = 'forYouInterestUpdated'
